export default __webpack_public_path__ + "static/media/rolamento-sinaleiro.48b3b927.png";